import { publicEnv } from '~/features/environment/public';
import { queryUdacityService } from '~/utils/query-udacity-service';

import { LinkedAccounts, linkedAccountsSchema } from '../models/user-linked-accounts';

export async function getLinkedAccounts({ jwt }: { jwt: string }): Promise<LinkedAccounts> {
  return await queryUdacityService({
    url: `${publicEnv.NEXT_PUBLIC_USER_URL}/me/linked_accounts`,
    method: 'GET',
    zodSchema: linkedAccountsSchema,
    authorization: `Bearer ${jwt}`,
  });
}
